import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-[#081632]" data-id="element-92" data-mp="1o2vigsgkwt85">
      <div className="max-w-4xl mx-auto" data-id="element-93" data-mp="223ek9hugb31v">
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-[#F5F7FB] border border-[#D89B16]/50 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-lg" data-id="element-94" data-mp="2223j7pse49eg">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-[#D89B16]" data-id="element-95" data-mp="1j4ahgqti65in" />
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-white text-[#D89B16] mb-8 border border-[#D89B16]/30" data-id="element-96" data-mp="1ee3u0uaq8r1z">
            <ShieldCheck size={48} data-id="element-97" data-mp="qmyc89l87op1" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-[#081632]" data-id="element-98" data-mp="lpg2igzdx5fz">
            🛡️ 7-Day Refund Policy
          </h2>
          <div className="space-y-6 text-lg text-slate-700 max-w-2xl mx-auto" data-id="element-99" data-mp="oyqck576zphk">
            <p data-id="element-100" data-mp="txt6athq29a8">You have 7 days to review the material after purchase.</p>
            <p className="font-medium text-[#081632]" data-id="element-101" data-mp="ypbcbvylr022">
              If the material you receive is incorrect, defective, incomplete or materially
              different from what was advertised, contact our support team within the applicable
              period and we will review the case according to our refund policy.
            </p>
            <p className="text-sm text-slate-500 mt-8" data-id="element-102" data-mp="b0jn9dgb6xti">
              The product is delivered digitally in PDF format.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}